import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
  DialogDescription,
} from "./ui/dialog";
import { Button } from "./ui/button";
import { AlertTriangle, Trash2, ArrowRight } from "lucide-react";

const DowngradeWarningDialog = ({
  open,
  onOpenChange,
  currentPlan,
  targetPlan,
  affectedFeatures = [],
  onConfirm,
  onCancel,
  loading = false,
}) => {
  const handleConfirm = () => {
    onConfirm?.();
  };

  const handleCancel = () => {
    onCancel?.();
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md" data-testid="downgrade-warning-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-amber-600">
            <AlertTriangle className="w-5 h-5" />
            Feature Data Warning
          </DialogTitle>
          <DialogDescription>
            You have used features that are not included in the {targetPlan?.name} plan.
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-4 py-4">
          {/* Current vs Target Plan */}
          <div className="flex items-center justify-center gap-3 p-3 rounded-lg bg-muted/50">
            <div className="text-center">
              <p className="text-xs text-muted-foreground">Current</p>
              <p className="font-semibold">{currentPlan || "Trial"}</p>
            </div>
            <ArrowRight className="w-4 h-4 text-muted-foreground" />
            <div className="text-center">
              <p className="text-xs text-muted-foreground">Selected</p>
              <p className="font-semibold">{targetPlan?.name}</p>
            </div>
          </div>

          {/* Affected Features */}
          <div className="space-y-2">
            <p className="text-sm font-medium text-destructive">
              The following data will be permanently deleted:
            </p>
            <div className="space-y-2">
              {affectedFeatures.map((feature, index) => (
                <div 
                  key={index} 
                  className="flex items-start gap-3 p-3 rounded-lg border border-destructive/20 bg-destructive/5"
                >
                  <Trash2 className="w-4 h-4 text-destructive flex-shrink-0 mt-0.5" />
                  <div>
                    <p className="text-sm font-medium">{feature.feature_name}</p>
                    <p className="text-xs text-muted-foreground">{feature.data_description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Upsell Message */}
          <div className="p-3 rounded-lg bg-blue-50 dark:bg-blue-950/30 border border-blue-200 dark:border-blue-900">
            <p className="text-sm text-blue-800 dark:text-blue-200">
              <strong>Keep your data!</strong> Consider upgrading to the{" "}
              <span className="font-semibold">Standard</span> plan to retain access to these features.
            </p>
          </div>
        </div>

        <DialogFooter className="flex gap-2 sm:gap-0">
          <Button 
            variant="outline" 
            onClick={handleCancel}
            disabled={loading}
          >
            Choose Different Plan
          </Button>
          <Button 
            variant="destructive" 
            onClick={handleConfirm}
            disabled={loading}
            data-testid="confirm-downgrade-btn"
          >
            {loading ? "Processing..." : "Delete Data & Continue"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default DowngradeWarningDialog;
